import {Container} from '@mantine/core'
import {createFileRoute} from '@tanstack/react-router'

import {JobsPage} from '../../../jobs/jobs-page'
import {validateJobListSearch} from '../../../jobs/jobs-search'

export const Route = createFileRoute('/_app/jobs/')({
    validateSearch: validateJobListSearch,
    component: JobsRoute,
})

function JobsRoute() {
    return (
        <Container size="lg" py="xl">
            <JobsPage />
        </Container>
    )
}
